export default __webpack_public_path__ + "static/media/knock.9c76dc42.wav";